import type { Dispatch } from 'redux';
import {
    createActionFactoryForFeature,
    Feature,
    FavoriteUnifiedGroup,
    PersonType,
    ThunkDispatch,
    createThunk,
    ownedUnifiedGroupsLeftNavId,
    groupHubUrlKey,
    groupHubOwnerFolderUrlKey,
} from '../../shared';
import { HubState, packageStateKey } from '../../hub';
import { getPackageState, getActiveLeftNavItemId, isInDeepLinkMode } from '../../appstate';
import navigateToRoute from 'owa-router/lib/navigateToRoute';
import { removeFavoritePersona } from '../../hub/actions/data/favoriteAddRemoveDataActions';

const actionFactory = createActionFactoryForFeature(Feature.UnifiedGroups);
export const editGroupClickedAction = actionFactory<{}>('EditGroupClickedAction');

export const editGroupCompletedAction = actionFactory<{
    groupId: string;
    tenantId: string;
    groupSmtp: string;
    photoUrl: string;
    hubPersonaId: string;
    oldGroupSmtp: string;
}>('EditGroupCompletedAction');

export const deleteGroupCompletedAction = actionFactory<{
    hubPersonaId: string;
    groupId: string;
    groupEmailAddress: string;
    mailboxGuid: string;
    nextGroupInList: string;
}>('DeleteGroupCompletedAction');

export const dismissEditGroupDialogAction = actionFactory<{}>('DismissEditGroupDialogAction');

export const editGroupClicked = (dispatch: Dispatch): void => {
    dispatch(editGroupClickedAction());
};

export const onDeleteCompleted = (dispatch: ThunkDispatch) => (
    hubPersonaId: string,
    groupId: string,
    groupEmailAddress: string,
    mailboxGuid: string,
    nextGroupInList: string,
    matchingFavorite: FavoriteUnifiedGroup
) => {
    if (!nextGroupInList) {
        dispatch(
            changeRouteIfNoNextGroup(
                hubPersonaId,
                groupId,
                groupEmailAddress,
                mailboxGuid,
                nextGroupInList
            )
        );
    } else {
        dispatch(
            deleteGroupCompletedAction({
                hubPersonaId,
                groupId,
                groupEmailAddress,
                mailboxGuid,
                nextGroupInList,
            })
        );
    }
    if (matchingFavorite) {
        dispatch(
            removeFavoritePersona(
                hubPersonaId,
                matchingFavorite.favoriteId,
                matchingFavorite.info.displayName,
                PersonType.Group
            )
        );
    }
};

export const onEditCompleted = (dispatch: Dispatch) => (
    groupId: string,
    tenantId: string,
    groupSmtp: string,
    photoUrl: string,
    hubPersonaId: string,
    oldGroupSmtp: string
) => {
    dispatch(
        editGroupCompletedAction({
            groupId,
            tenantId,
            groupSmtp,
            photoUrl,
            hubPersonaId,
            oldGroupSmtp,
        })
    );
};

export const dismissEditGroupDialog = (dispatch: Dispatch): void => {
    dispatch(dismissEditGroupDialogAction());
};

const changeRouteIfNoNextGroup = (
    hubPersonaId: string,
    groupId: string,
    groupEmailAddress: string,
    mailboxGuid: string,
    nextGroupInList: string
) =>
    createThunk('ChangeRouteIfNoNextGroup', (dispatch: ThunkDispatch, getState: () => {}): void => {
        const packageState = getPackageState<HubState>(getState(), packageStateKey);
        if (packageState) {
            var entries = packageState.appState.data.groupsHubState.ownedGroupsIds.map(
                key => packageState.appState.data.groupsHubState.unifiedGroupsMap[key]
            );
            if (
                getActiveLeftNavItemId(packageState.appState) === ownedUnifiedGroupsLeftNavId ||
                (entries.length == 0 && isInDeepLinkMode(packageState.appState))
            ) {
                navigateToRoute([groupHubUrlKey, groupHubOwnerFolderUrlKey]);
            }
        }
        dispatch(
            deleteGroupCompletedAction({
                hubPersonaId,
                groupId,
                groupEmailAddress,
                mailboxGuid,
                nextGroupInList,
            })
        );
    });
export type { Action } from '../../shared';
